import styles from "../../../pages/Admin/Admin.module.css";
import {Link} from "react-router-dom";
import ActiviteTypeTable from "./ActiviteTypeTable";
import React from "react";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import Routing from "../../../services/routing";

const ActiviteTypesVue = ({ activitesTypes, putActifOpenModal, setImage = null }) => {

    return (
        <>
            <div className={styles.navLink}>
                <Link to={Routing.routes.adminCreation}>
                    <AjouterIcone />
                    Ajouter un type d'activité
                </Link>
            </div>

            <ActiviteTypeTable activiteTypes={activitesTypes} putActifOpenModal={putActifOpenModal} setImage={setImage}/>
        </>
    )
}

export default ActiviteTypesVue;